// libs
import styled from 'styled-components'
// themes
import colors from 'themes/colors'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: ${colors.gray300};
`
